import React from "react";

import MessengerCustomerChat from "react-messenger-customer-chat";

const MessengerData = () => {
  return (
    <div>
      <MessengerCustomerChat pageId="105142171669869" appId="844497209480002" />
    </div>
  );
};
export default MessengerData;
